import {extendObservable, reaction} from 'mobx';
import {Exclude, Expose, classToPlain} from "class-transformer";
import {simplyDeserialize} from "../../common_components/serialization/common";

 
@Exclude()
export default class FeedbackParticipant{

    constructor(id, feedbackChain, store, persisted = true, participant = undefined, jsonAttributes = {}) {
        this.store = store;

        extendObservable(this, {
            @Expose()
            id: id,

            feedbackChain: feedbackChain,

            @Expose()
            creator: false,

            @Expose()
            assignee: jsonAttributes.assignee || false,

            @Expose()
            mailNotifications: jsonAttributes.mailNotifications || false,

            @Expose()
            webNotifications: jsonAttributes.webNotifications || false,

            participant: participant || [],

            persisted: persisted,
        });

        this.autoUpdate = true;

        // Automatically update in backend when there is any change in
        // the assignee, mailNotifications or webNotifications attributes
        let updateDisposer = reaction( () => {
                let trackedData = {
                    assignee: this.assignee,
                    mailNotifications: this.mailNotifications,
                    webNotifications: this.webNotifications
                }
                return trackedData;
            },
            () => {
                if( this.persisted && this.autoUpdate ){
                    if( this.store ){
                        this.store.updateBackend(this);
                    }
                }
            });
    }

    serialize(){
        return classToPlain(this);
    }

    toJson(){
        return this.serialize();
    }

    updateFromJson(json, avoidUpdate = true){
        const oldAutoUpdate = this.autoUpdate;
        this.autoUpdate = avoidUpdate ? false : oldAutoUpdate;
        this.id = json.id || this.id;
        this.assignee = json.assignee || this.assignee;
        this.mailNotifications = json.mailNotifications != undefined ? json.mailNotifications : this.mailNotifications;
        this.webNotifications = json.webNotifications != undefined ? json.webNotifications : this.webNotifications;
        this.autoUpdate = oldAutoUpdate;
    }

    static deserialize(json, feedbackChain, store){
        let result = simplyDeserialize(FeedbackParticipant, json);
        result.feedbackChain = feedbackChain;
        result.store = store;
        return result;
    }

}

FeedbackParticipant.allowedInstanceProperties = ['id','creator','assignee','mailNotifications','webNotifications','participant']

